module.exports = __webpack_public_path__ + "img/clock.6555b075.svg";